import React from 'react';
import FormButton from "../../../../library/form/components/FormActionButton2"

const DashViewRow = (props) => {
    const { formObject, rowKey, viewData, onClick, filterDate, selectedRow } = props;

    const onSuccess = (action, containerKey, rKey, headerKey, response) => {
        // console.log("view id check", viewData.val, response);
        onClick(viewData.val, viewData.dataList.valLDT, response.viewData);
    }

    return (
        <li className="uiInlineFlex">
            <FormButton className={selectedRow === viewData.val ? "uiTabActiveButtonLook" : "uiTabButtonLook"} formObject={formObject} rowKey="" headerKey="DashViews"
                action={{ actionId: "show",  paramName: rowKey, actionMessage:"Loading Dashboard Data",
                actionParam: { tdoctyid:"%dataList.valLDT",dshv_rowId:'%val', cSDate:filterDate, sview:"D" }, 
                containerKey: "custom", onSuccess: onSuccess }}
            />
        </li>
    )
}

export default DashViewRow
